/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ email: NonNullable<unknown> }} License_Error_RevokedInputs */



/**
* | output |
* | --- |
* | "This licence is no longer active. Contact {email}." |
*
* @param {License_Error_RevokedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const license_error_revoked = /** @type {((inputs: License_Error_RevokedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<License_Error_RevokedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Cette licence n'est plus active. Contactez ${i?.email}.`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Diese Lizenz ist nicht mehr aktiv. Wenden Sie sich an ${i?.email}.`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Questa licenza non è più attiva. Contatta ${i?.email}.`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Эта лицензия больше не действует. Напишите на ${i?.email}.`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Esta licencia ya no está activa. Escribe a ${i?.email}.`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`此许可证已失效。请联系 ${i?.email}。`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`このライセンスは無効になっています。${i?.email} までお問い合わせください。`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`यह लाइसेंस अब सक्रिय नहीं है। ${i?.email} से संपर्क करें।`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Esta licença já não está ativa. Contacte ${i?.email}.`)
	return /** @type {LocalizedString} */ (`This licence is no longer active. Contact ${i?.email}.`)
});